// @flow
import React from 'react';
import moment from 'moment';
import FlatButton from 'material-ui/FlatButton';
import { withTheme } from 'styled-components';

type Props = {
  selectedDate: moment;
  monthName: string;
  minDate?: moment;
  maxDate?: moment;
  onClick: (monthIndex: number) => void;
  currentYear: number;

  theme: any;
};

class MonthButton extends React.Component<Props> {
  getMonthIndex() {
    return moment.monthsShort().indexOf(this.props.monthName);
  }

  isDisabled = () => {
    const { minDate, maxDate, currentYear } = this.props;
    const monthIndex = this.getMonthIndex();

    const isBeforeMinDate = minDate &&
      ((currentYear === minDate.year() && monthIndex < minDate.month()) || currentYear < minDate.year());
    const isAfterMaxDate = maxDate &&
      ((currentYear === maxDate.year() && monthIndex > maxDate.month()) || currentYear > maxDate.year());

    return isBeforeMinDate || isAfterMaxDate;
  };

  render() {
    const { theme, selectedDate, monthName, onClick, currentYear } = this.props;

    const monthIndex = this.getMonthIndex();
    const isSelectedMonth = selectedDate.month() === monthIndex && selectedDate.year() === currentYear;
    const style = isSelectedMonth ? { backgroundColor: theme.colors.primary, color: theme.colors.tertiaryText } : {};
    return (
      <FlatButton
        key={monthName}
        onClick={() => onClick(monthIndex)}
        style={style}
        label={monthName}
        disabled={this.isDisabled()}
      />
    );
  }
}

export default withTheme(MonthButton);



// WEBPACK FOOTER //
// ./src/common/components/monthlyDateRangePicker/MonthButton.js